import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareLinesBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareLinesBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM6 14H13V16H6V14ZM15 14H18V16H15V14ZM6 10V12H9V10H6ZM11 10V12H18V10H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareLinesBottom;
